export default __webpack_public_path__ + "static/media/BaishanMap.4e115fdf.jpg";